import { FunctionComponent, useEffect } from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';

// components
import Head from 'next/head';
import Anchor from '@Components/Utils/Anchor';
import ImgLazy from '@Components/Utils/Lazy/Image';
import Layout from '@Pages/bai-viet/Components/Layout';
import Banner from '@Pages/bai-viet/Components/Banner';
// import ListPost from '@Pages/bai-viet/Components/Posts';
// import HotView from '@Pages/bai-viet/Components/HotView';
import ComponentLazy from '@Components/Utils/Lazy/Component';

// Contexts
import { usePostsManager, withPostsManager } from './Contexts/posts';
import { ViewMedia, useViewDetected } from '@Components/Utils/ViewDetected';

// Types
import { NextSeoProps } from 'next-seo';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';

// Api
import postApi from '@Libs/api/cms/posts';
import { getServerSideHttp } from '@Libs/http/cms';
import postHomePageApi from '@Libs/api/cms/postHomePage';
import postCategoriesApi from '@Libs/api/cms/postCategories';

// styles
import styles from './PostPage.module.scss';

const Posts: FunctionComponent<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ postHome }) => {
    const router = useRouter();
    const { deviceType } = useViewDetected();
    const { posts, setCategory } = usePostsManager();

    const categoryId: any = router.query.danh_muc;
    useEffect(() => {
        setCategory(categoryId);
    }, [categoryId]);

    const handleSearch = (keyword: string) => router.push(`/bai-viet/tim-kiem?s=${keyword}`);

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);

    const hotBanner = postHome.hotBanner || {};
    const [firstSlide] = postHome.slide || [];

    return (
        <Layout onSearch={handleSearch}>
            <Head>
                {deviceType === 'desktop' && firstSlide?.image?.url && <link rel={'preload'} as={'image'} href={`${firstSlide?.image?.url}?width=860`} />}
                {hotBanner?.image?.url && <link rel={'preload'} as={'image'} href={`${hotBanner?.image?.url}?width=${deviceType === 'desktop' ? '300' : '400'}`} />}
            </Head>

            <div className={wrapperClassName}>
                <ViewMedia is="desktop">
                    {/* <ComponentLazy dynamic={() => import('@Pages/bai-viet/Components/Banner')} slide={postHome.slide} highlight={postHome.highlight} /> */}
                    <Banner className={styles.banner} slide={postHome.slide} highlight={postHome.highlight} />
                </ViewMedia>

                <ComponentLazy
                    className={styles.hot_view}
                    hotBanner={postHome.hotBanner}
                    dynamic={() => import('@Pages/bai-viet/Components/HotView')}
                    placeholder={() => <div style={{ height: deviceType === 'mobile' ? '321px' : '260px', backgroundColor: '#fff', order: 3 }} />}
                />
                {/* <HotView hotBanner={postHome.hotBanner} className={styles.hot_view} /> */}

                <div className={classnames([styles.posts])}>
                    <ViewMedia is={['mobile', 'tablet']}>
                        <Anchor href={hotBanner?.link?.href}>
                            <ImgLazy width={344} height={192} src={`${hotBanner?.image?.url}?width=400`} alt={hotBanner?.image?.alternativeText || 'eDoctor'} className={styles.view_banner} />
                        </Anchor>
                    </ViewMedia>

                    <ComponentLazy dynamic={() => import('@Pages/bai-viet/Components/Posts')} categories={postHome.categories} posts={posts} />
                    {/* <ListPost categories={postHome.categories} posts={posts} /> */}
                </div>
            </div>
        </Layout>
    );
};

export default withPostsManager(Posts)(12);

export const getServerSideProps: GetServerSideProps = async (ctx) => {
    const http = getServerSideHttp(ctx);
    const categoryId = ctx?.query?.danh_muc || '';

    const [posts, category, postHome] = await Promise.all([
        await postApi(http).find({
            ...(categoryId && { category: categoryId }),
            _limit: 12,
            _start: 0,
        }),
        categoryId && (await postCategoriesApi(http).findOne(categoryId)),
        await postHomePageApi(http).find(),
    ]);

    const seo: NextSeoProps = {
        title: 'eDoctor: Thư viện sức khỏe',
    };

    return {
        props: {
            seo,
            posts,
            category,
            postHome,
        },
    };
};
